import { browserHistory } from 'react-router'

/**
 * The current route's query params. Values are `unknown` on purpose:
 * react-router hands back an ARRAY for a repeated key (`?a=1&a=2`), so a reader
 * must narrow before touching a string method — and {@link replaceOwnedQuery}
 * drops such a key on the next write anyway.
 */
export const currentQuery = (): Record<string, unknown> =>
  (browserHistory.getCurrentLocation().query || {}) as Record<string, unknown>

/**
 * Patch `nextOwned` onto the current query without dropping keys owned by
 * sibling panels on the same route (Benefits vs Transaction Details).
 * Clears previous values for `ownedKeys` first so omitted filters actually
 * leave the URL instead of lingering from the last write.
 */
export const replaceOwnedQuery = (
  ownedKeys: readonly string[],
  nextOwned: Record<string, string>
): void => {
  const location = browserHistory.getCurrentLocation()
  const current = (location.query || {}) as Record<string, unknown>
  const owned = new Set(ownedKeys)
  const query: Record<string, string> = {}
  Object.keys(current).forEach((key) => {
    if (owned.has(key)) return
    const value = current[key]
    if (typeof value === 'string' && value !== '') query[key] = value
  })
  Object.assign(query, nextOwned)
  browserHistory.replace({
    pathname: location.pathname,
    query,
  })
}
